import axios from '@/axios'

// grade volumes

export async function listGradeVolumes (gradeId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + gradeId + '/volumes')
  return response.data.data
}

export async function newGradeVolume (gradeId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + gradeId + '/volumes', data)
  return response.data.data
}

export async function getGradeVolume (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/grade-volumes/' + id)
  return response.data.data
}

export async function updateGradeVolume (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/grade-volumes/' + id, data)
  return response.data.data
}

export async function deleteGradeVolume (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/grade-volumes/' + id)
  return response.data.data
}

export default {
  listGradeVolumes,
  newGradeVolume,
  getGradeVolume,
  updateGradeVolume,
  deleteGradeVolume
}
